import styles from "@css/modules/ResortSections.module.scss"
import { DiningLocationItem } from "./DiningLocationItem"
import { Tabs } from "antd"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import { SlideAppear } from "../../../Animation/SlideAppear"
import { useMemo } from "react"

export function DiningLocations({ diningLocations = [] }) {
    const isMobile = useMediaQuery("(max-width: 1024px)", true)
    const items = useMemo(
        () =>
            diningLocations?.map((i, index) => {
                return {
                    label: <div className={styles.tabTitle}>{i.tabTitle}</div>,
                    key: index,
                    children: i.diningItems?.map((j, jIndex) => <DiningLocationItem {...j} key={`${index}-${jIndex}`} />)
                }
            }),
        [diningLocations]
    )
    if (!diningLocations?.length) return null
    return (
        <SlideAppear className={styles.diningLocations}>
            <div className={styles.overLocations}>
                <Tabs defaultActiveKey={0} tabBarGutter={isMobile ? 24 : 57} className={styles.tabsWrapper} items={items} />
            </div>
        </SlideAppear>
    )
}
